export const IS_BROWSER: boolean =
  typeof window !== 'undefined' && typeof window.document !== 'undefined';
